import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    margin: theme.spacing(3, 0, 5, 0),
    padding: theme.spacing(2),
  },
  header: {
    padding: 0,
    marginBottom: theme.spacing(2),
  },
  title: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
  },
  toggles: {
    marginRight: theme.spacing(4),
  },
  titleToggleAndDateContainer: {
    display: 'flex',
  },
}));

export default useStyles;
